import React, { useCallback, useContext } from 'react';
import {
  Redirect, Route, RouteComponentProps,
} from 'react-router-dom';
import Loader from 'components/layouts/modal/Loader';
import PopUp from 'components/layouts/modal/PopUp';
import PopUpV2 from '_revamp/molecules/modal/popUp';
import ModalAdd from 'components/layouts/modal/AddBoard';
import { Hooks } from 'providers';
import { useSelector } from 'react-redux';
import Wrapper from 'components/layouts/Main';
// organization
import ModalAddStructureNode from 'components/organizations/structure-view/ModalForm';
import ModalUpdateStructureNode from 'components/organizations/structure-view/ModalFormUpdate';
// employee
import ModalAddEmployeeNode from 'components/organizations/employees/ModalForm';
import ModalUpdateEmployeeNode from 'components/organizations/employees/ModalFormUpdate';
import { Organization } from 'providers/Organization';
import { Matrix } from 'providers/Matrix';

import ModalAssessment from 'components/workloadAssessment/analytics/parts/PopUpAssessment';
import ModalConflict from 'components/matrix/modal/ConflictData';
import Maintenance from 'components/layouts/maintenance';

type LoggedProps = {
  readonly component: React.ElementType;
  readonly header?: boolean;
  readonly matrix?: boolean;
  readonly path: string;
  readonly exact?: boolean;
  readonly loginType?: string;
  readonly [key: string]: unknown;
};

interface LoggedRootState {
  readonly loading?: {
    readonly loading?: boolean;
  };
}

type ModalSetter = (value: boolean) => void;

type MatrixContextValue = {
  readonly setModalAudit: ModalSetter;
  readonly setModalSummary: ModalSetter;
  readonly setModalConflict: ModalSetter;
};

type HooksContextValue = {
  readonly modal?: boolean;
  readonly setModal: ModalSetter;
  readonly setModalDelete: ModalSetter;
  readonly setModalAdd: ModalSetter;
  readonly setModalAssessment: ModalSetter;
  readonly text?: {
    readonly member_id?: unknown;
  };
};

type OrganizationContextValue = {
  readonly setModal: ModalSetter;
  readonly setModalUpdate: ModalSetter;
  readonly setEmployeeModal: ModalSetter;
  readonly setModalAddEmployee: ModalSetter;
};

function Logged({
  component: Component, header = false, matrix: routeMatrix = false, ...rest
}: LoggedProps) {
  void routeMatrix;
  const { setModalAudit, setModalSummary, setModalConflict } = useContext(Matrix) as MatrixContextValue;
  const {
    modal,
    setModal,
    setModalDelete,
    setModalAdd,
    setModalAssessment,
    text,
  } = useContext(Hooks) as HooksContextValue;
  const {
    setModal: setOrganizationModal,
    setModalUpdate,
    setEmployeeModal,
    setModalAddEmployee,
  } = useContext(Organization) as OrganizationContextValue;
  const { loading } = useSelector((state: LoggedRootState) => ({
    loading: state.loading?.loading,
  }));

  const closeAll = useCallback(() => {
    setModalAudit(false);
    setModalSummary(false);
    setEmployeeModal(false);
    setModalAddEmployee(false);
    setModal(false);
    setModalUpdate(false);
    setOrganizationModal(false);
    setModalDelete(false);
    setModalAdd(false);
    setModalConflict(false);
    setModalAssessment(false);
  }, [
    setEmployeeModal,
    setModal,
    setOrganizationModal,
    setModalAdd,
    setModalAddEmployee,
    setModalAssessment,
    setModalAudit,
    setModalConflict,
    setModalDelete,
    setModalSummary,
    setModalUpdate,
  ]);

  const shouldShowBackdrop = Boolean(modal && !text?.member_id);
  const tokenV2 = localStorage.getItem('tokenV2');
  if (
    process.env.REACT_APP_LIST_MAINTENANCE.length > 0
    && process.env.REACT_APP_LIST_MAINTENANCE.split(', ').includes(rest.path)
  ) {
    return (
      <Route
        {...rest}
        render={() => (
          <Maintenance />
        )}
      />
    );
  }
  if (tokenV2 === null) {
    const roleV2 = localStorage.getItem('historyV2');
    if (roleV2 === 'adminV2') {
      return <Redirect to="/v2/kpi/login" />;
    }
    return <Redirect to="/v2/kpi/login-employee" />;
  }

  return (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => (
        <>
          {loading && <Loader />}
          {header ? (
            <Wrapper {...rest}>
              <Component {...props} />
            </Wrapper>
          ) : (
            <Component {...props} />
          )}

          <PopUp />
          <PopUpV2 />
          <ModalAdd />

          <ModalAddStructureNode title="Add Structure Node" />
          <ModalUpdateStructureNode title="Edit Structure Node" />
          <ModalAddEmployeeNode title="Add Employee Node" />
          <ModalUpdateEmployeeNode title="Edit Employee Node" />
          <ModalAssessment />
          <ModalConflict />
          {shouldShowBackdrop && (
            <button
              type="button"
              onClick={closeAll}
              aria-label="Close modal backdrop"
              className="modal-backdrop fade show"
              style={{
                border: 0,
                padding: 0,
                transition: 'all 0.5s ease',
              }}
            />
          )}
        </>
      )}
    />
  );
}

export default Logged;
